import _asyncToGenerator from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/regenerator/index.js";
import { getStyleFromHsl } from "tsparticles-engine";
var currentColorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d.]+%?\))|currentcolor/gi;

function replaceColorSvg(imageShape, color, opacity) {
  var svgData = imageShape.svgData;

  if (!svgData) {
    return "";
  }

  var colorStyle = getStyleFromHsl(color, opacity);

  if (svgData.includes("fill")) {
    return svgData.replace(currentColorRegex, function () {
      return colorStyle;
    });
  }

  var preFillIndex = svgData.indexOf(">");
  return "".concat(svgData.substring(0, preFillIndex), " fill=\"").concat(colorStyle, "\"").concat(svgData.substring(preFillIndex));
}

export function loadImage(_x) {
  return _loadImage.apply(this, arguments);
}

function _loadImage() {
  _loadImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(image) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              image.loading = true;
              var img = new Image();
              image.element = img;
              img.addEventListener("load", function () {
                image.loading = false;
                resolve();
              });
              img.addEventListener("error", function () {
                image.element = undefined;
                image.error = true;
                image.loading = false;
                console.error("Error tsParticles - loading image: ".concat(image.source));
                resolve();
              });
              img.src = image.source;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadImage.apply(this, arguments);
}

export function downloadSvgImage(_x2) {
  return _downloadSvgImage.apply(this, arguments);
}

function _downloadSvgImage() {
  _downloadSvgImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(image) {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(image.type !== "svg")) {
              _context3.next = 4;
              break;
            }

            _context3.next = 3;
            return loadImage(image);

          case 3:
            return _context3.abrupt("return");

          case 4:
            image.loading = true;
            _context3.next = 7;
            return fetch(image.source);

          case 7:
            response = _context3.sent;

            if (!response.ok) {
              console.error("Error tsParticles - Image not found");
              image.error = true;
            }

            if (image.error) {
              _context3.next = 13;
              break;
            }

            _context3.next = 12;
            return response.text();

          case 12:
            image.svgData = _context3.sent;

          case 13:
            image.loading = false;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _downloadSvgImage.apply(this, arguments);
}

export function replaceImageColor(image, imageData, color, particle) {
  var _a, _b, _c;

  var svgColoredData = replaceColorSvg(image, color, (_b = (_a = particle.opacity) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 1),
      imageRes = {
    color: color,
    data: Object.assign(Object.assign({}, image), {
      svgData: svgColoredData
    }),
    loaded: false,
    ratio: imageData.width / imageData.height,
    replaceColor: (_c = imageData.replaceColor) !== null && _c !== void 0 ? _c : imageData.replace_color,
    source: imageData.src
  };
  return new Promise(function (resolve) {
    var svg = new Blob([svgColoredData], {
      type: "image/svg+xml"
    }),
        domUrl = URL || window.URL || window.webkitURL || window,
        url = domUrl.createObjectURL(svg),
        img = new Image();
    img.addEventListener("load", function () {
      imageRes.loaded = true;
      imageRes.element = img;
      resolve(imageRes);
      domUrl.revokeObjectURL(url);
    });
    img.addEventListener("error", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var img2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              domUrl.revokeObjectURL(url);
              img2 = Object.assign(Object.assign({}, image), {
                error: false,
                loading: true
              });
              _context.next = 4;
              return loadImage(img2);

            case 4:
              imageRes.loaded = true;
              imageRes.element = img2.element;
              resolve(imageRes);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    img.src = url;
  });
}